module.exports = __webpack_public_path__ + "img/calendar.9fa2508a.png";